// extracted by mini-css-extract-plugin
module.exports = {"errorNotification":"ErrorNotification_errorNotification__o67E8","icon":"ErrorNotification_icon__1dqBC","text":"ErrorNotification_text__1BJtt"};